// @flow
// eslint-disable-next-line no-unused-vars
import type { AxiosPromise } from 'axios';

import qs from 'store/entities/QueryString';
import xws from 'api/clients/xws';
import type { PersonInfo } from './entities/PersonInfo';
import OAuth from 'utils/oauth/OAuth';

export type SocialLoginResponse = {|
  success: number,
  statusCode: number,
  key: string,
  authTokenId: string,
  personInfo: PersonInfo
|};

export type RequestData = {
  webkey: string,
  locale: string,
  channel: string,
  socialProviderUserTokenId: string,
  customerId?: string
};

export function socialLoginWs(opts: {|
  provider: OAuth,
  webkey: string,
  locale: string,
  channel: number,
  socialProviderUserTokenId: string,
  personId?: string
|}): AxiosPromise<RequestData, SocialLoginResponse> {
  const { provider, webkey, locale, channel, socialProviderUserTokenId } = opts;
  // TODO(mauricio): the mock should be outside the application e.g. should be
  // the response of a proxy server
  if (qs.has('_socialDebug')) {
    let mock = import('./mock/googleSocialLoginSuccess.json');
    const queryParamDebug = qs.get('_socialDebug');
    if (queryParamDebug === 'notFound') {
      mock = import('./mock/googleSocialLoginNotFound.json');
    } else if (queryParamDebug === 'noAppt') {
      mock = import('./mock/googleSocialLoginNoAppt.json');
    }
    return mock.then(
      response =>
        ({
          data: response
          // mapped as any because the mocked response only needs the data field
          // and not the other AxiosXHR fields
        }: any)
    );
  }

  const data: RequestData = {
    webkey,
    locale,
    channel: String(channel),
    socialProviderUserTokenId
  };
  if (opts.personId) {
    data.customerId = opts.personId;
  }

  return xws.request({
    url: `rest/customer/social/${provider.getName()}/login`,
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/xws/login/socialLoginWs.js